import { useTenantSetting } from "@nestoca/multi-tenant";
import { Box, Flex, type ModalProps, Typography } from "@nestoca/ui";
import { useTranslation } from "react-i18next";

import { DeleteAccountButton } from "../../delete-account/delete-account-button";

import styles from "./user-settings-modal.module.scss";

type Props = Pick<ModalProps, "onClose"> & { locale: string | undefined };

export const AccountManagementSection = ({ onClose, locale }: Props) => {
  const { t } = useTranslation();
  const { value: enableDeleteAccount } = useTenantSetting("enableDeleteAccount");

  if (!enableDeleteAccount) return null;

  return (
    <Flex gap={2} mt={8} direction="column" className={styles.section}>
      <h2 className={styles.title}>{t("accountDeletion.modal.title")}</h2>
      <Typography>{t("accountDeletion.modal.description")}</Typography>
      <Box>
        <DeleteAccountButton
          onClick={() => {
            onClose?.();
            const linkLocale = locale === "en" ? "" : `/${locale}`;
            window.location.href = `${window.location.origin}${linkLocale}/disable-account`;
          }}
        />
      </Box>
    </Flex>
  );
};
